var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
var MovementsStore = assign({}, ModelStore, {
	getResourceListData: function () {
		//return this._mutateAttributes();
		return _resourceListData;
	}
});

/**
 * Event Listeners
 */
MovementsStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'MOVEMENTS_LISTED':
			_resourceListData = action.data;

			MovementsStore.emitChange();
			break;
	}
});

module.exports = MovementsStore;
